import {
  AttFileControllerService,
  BoardCommonControllerService,
  BoardVo,
} from '@/__generated__/CommonApi';
import {
  CorporateControllerService,
  CsrVo,
  FoBannerControllerService,
  FoBannerVo,
} from '@/__generated__/FrontApi';
import UnicefImg1 from '@/assets/img/corporate-and-organization/contri_method_obj01@2x.png';
import UnicefImg2 from '@/assets/img/corporate-and-organization/contri_method_obj02@2x.png';
import UnicefImg3 from '@/assets/img/corporate-and-organization/contri_method_obj03@2x.png';
import UnicefImg4 from '@/assets/img/corporate-and-organization/contri_method_obj04@2x.png';
import UnicefImg5 from '@/assets/img/corporate-and-organization/contri_onepercent.png';
import UnicefImg5M from '@/assets/img/corporate-and-organization/contri_onepercentM@2x.png';
import ContributionImg1 from '@/assets/img/corporate-and-organization/contribution_img1@2x.jpg';
import ContributionImg1On from '@/assets/img/corporate-and-organization/contribution_img1_on@2x.jpg';
import ContributionImg2 from '@/assets/img/corporate-and-organization/contribution_img2@2x.jpg';
import ContributionImg2On from '@/assets/img/corporate-and-organization/contribution_img2_on@2x.jpg';
import ContributionImg3 from '@/assets/img/corporate-and-organization/contribution_img3@2x.jpg';
import ContributionImg3On from '@/assets/img/corporate-and-organization/contribution_img3_on@2x.jpg';
import ContributionImg4 from '@/assets/img/corporate-and-organization/contribution_img4@2x.jpg';
import ContributionImg4On from '@/assets/img/corporate-and-organization/contribution_img4_on@2x.jpg';
import ContributionImg5 from '@/assets/img/corporate-and-organization/contribution_img5@2x.jpg';
import ContributionImg5On from '@/assets/img/corporate-and-organization/contribution_img5_on@2x.jpg';
import ContributionImg6 from '@/assets/img/corporate-and-organization/contribution_img6@2x.jpg';
import ContributionImg6On from '@/assets/img/corporate-and-organization/contribution_img6_on@2x.jpg';
import partnerLogo1 from '@/assets/img/corporate-and-organization/contribution_partner1@2x.png';
import partnerLogo1M from '@/assets/img/corporate-and-organization/contribution_partner1_m@2x.png';
import partnerLogo2 from '@/assets/img/corporate-and-organization/contribution_partner2@2x.png';
import partnerLogo2M from '@/assets/img/corporate-and-organization/contribution_partner2_m@2x.png';
import partnerLogo3 from '@/assets/img/corporate-and-organization/contribution_partner3@2x.png';
import partnerLogo3M from '@/assets/img/corporate-and-organization/contribution_partner3_m@2x.png';
import partnerLogo4 from '@/assets/img/corporate-and-organization/contribution_partner4@2x.png';
import partnerLogo4M from '@/assets/img/corporate-and-organization/contribution_partner4_m@2x.png';
import partnerLogo5 from '@/assets/img/corporate-and-organization/contribution_partner5@2x.png';
import partnerLogo6 from '@/assets/img/corporate-and-organization/contribution_partner6@2x.png';
import Obj0 from '@/assets/img/corporate-and-organization/ico_contribution_heart@2x.png';
import Obj1 from '@/assets/img/corporate-and-organization/ico_contribution_obj01@2x.png';
import Obj2 from '@/assets/img/corporate-and-organization/ico_contribution_obj02@2x.png';
import Obj3 from '@/assets/img/corporate-and-organization/ico_contribution_obj03@2x.png';
import Obj4 from '@/assets/img/corporate-and-organization/ico_contribution_obj04@2x.png';
import processObj1 from '@/assets/img/corporate-and-organization/partnership_process_obj01@2x.png';
import processObj2 from '@/assets/img/corporate-and-organization/partnership_process_obj02@2x.png';
import processObj3 from '@/assets/img/corporate-and-organization/partnership_process_obj03@2x.png';
import processObj4 from '@/assets/img/corporate-and-organization/partnership_process_obj04@2x.png';
import processObj5 from '@/assets/img/corporate-and-organization/partnership_process_obj05@2x.png';
import processObj6 from '@/assets/img/corporate-and-organization/partnership_process_obj06@2x.png';
import IcoShare from '@/assets/img/icons/ico_share@2x.png';
import ArrowDownBlue from '@/assets/img/icons/icon_arrow_down_sky@2x.png';
import AccordionComponent, { AccordionItem } from '@/components/Accordion';
import Attachment from '@/components/Attachment';
import Button from '@/components/Button';
import CampaignCard, { CampaignData } from '@/components/Card/CampaignCard';
import ThumbnailCardSample from '@/components/Card/ThumbnailCardSample';
import ContactUs from '@/components/ContactUs';
import Container from '@/components/Container';
import ContributionLogo, {
  CategoryData,
  PartnerData,
} from '@/components/ContributionLogo';
import ErrorMessage from '@/components/Form/ErrorMessage';
import FormGroup from '@/components/Form/FormGroup';
import LabelText from '@/components/Form/LabelText';
import Row from '@/components/Grid/Row';
import Image from '@/components/Image';
import InputCheckbox from '@/components/Input/InputCheckbox';
import InputNumber from '@/components/Input/InputNumber';
import InputText from '@/components/Input/InputText';
import InputTextarea from '@/components/Input/InputTextarea';
import LinkSafe from '@/components/LinkSafe';
import PageComponent from '@/components/PageComponent';
import { ProcessList } from '@/components/ProcessList';
import Section, { SectionNews } from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import SwiperBasic from '@/components/Swiper/SwiperBasic';
import { MoreViewLink, Tit } from '@/components/Titles';
import { EVENT_LIST_URI, BOARD_KIND_PARTNER } from '@/helpers/BoardHelper';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { emailRegex, mobileRegex } from '@/helpers/ValidationHelper';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
import { ADDRESS } from '@/page-blocks/involve/ContactCommon';
import { ContributionTab } from '@/page-blocks/involve/corporate-and-organization/social-contribution';
import { usePopupStore } from '@/stores/PopupStore';
import { useLocation } from '@reach/router';
import { PageProps } from 'gatsby';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

const partnerListData = [
  {
    id: 1,
    link: `/involve/corporate-and-organization/bighit`,
    sources: '',
    img: ContributionImg6,
    imgOn: ContributionImg6On,
    logo: partnerLogo6,
    logoM: partnerLogo6,
    partner: 'Bighit Music',
  },
  {
    id: 2,
    link: `/involve/corporate-and-organization/smentertainment`,
    sources: '© 유니세프 한국위원회',
    img: ContributionImg4,
    imgOn: ContributionImg4On,
    logo: partnerLogo4,
    logoM: partnerLogo4M,
    partner: 'SM entertainment',
  },
  {
    id: 3,
    link: `/involve/corporate-and-organization/kakaobank`,
    sources: '© 2024 save race',
    img: ContributionImg1,
    imgOn: ContributionImg1On,
    logo: partnerLogo1,
    logoM: partnerLogo1M,
    partner: 'Kakaobank',
  },
  {
    id: 4,
    link: `/involve/corporate-and-organization/shinhancard`,
    sources: '© 유니세프 한국위원회',
    img: ContributionImg3,
    imgOn: ContributionImg3On,
    logo: partnerLogo3,
    logoM: partnerLogo3M,
    partner: '신한카드',
  },
  {
    id: 5,
    link: `/involve/corporate-and-organization/bgfretail`,
    sources: '© UNICEF/UNI719423/Sokhin',
    img: ContributionImg2,
    imgOn: ContributionImg2On,
    logo: partnerLogo2,
    logoM: partnerLogo2M,
    partner: 'BGF',
  },
  {
    id: 6,
    link: `/involve/corporate-and-organization/wooricap`,
    sources: '',
    img: ContributionImg5,
    imgOn: ContributionImg5On,
    logo: partnerLogo5,
    logoM: partnerLogo5,
    partner: 'JB우리캐피탈',
  },
];

const countingData = [
  {
    id: 1,
    number: `6,700,000`,
    unit: '명',
    img: Obj1,
    desc: [
      {
        id: 11,
        dec: `
          670만 명에게 기후변화에 <br />
          강한 수도시설을 지원했습니다.
        `,
      },
    ],
  },
  {
    id: 2,
    number: `251,000,000`,
    unit: '명',
    img: Obj2,
    desc: [
      {
        id: 21,
        dec: `
          <strong>전 세계 5세 미만 어린이</strong><br />
          <strong>2억 5,100만 명이</strong> 소모성 영양실조
          조기진단 서비스를 받았으며,<br />
          930만 명은 중증 소모성 영양실조 및
          기타 급성 영양실조에 대한 치료를
          받았습니다.
        `,
      },
    ],
  },
  {
    id: 3,
    number: `1,500,000,000`,
    unit: '회',
    img: Obj3,
    desc: [
      {
        id: 31,
        dec: `
          <strong>15억 회 이상의 소아마비 백신이
          87개국에 전달되어,</strong><br />
          2023년에서 2024년 사이 전 세계
          소아마비 발병률을 약 25%
          감소시키는 데 기여했습니다.
        `,
      },
    ],
  },
  {
    id: 4,
    number: `26,000,000`,
    unit: '명',
    img: Obj4,
    desc: [
      {
        id: 41,
        dec: `
          2600만 명의 어린이와 청소년이
          교육 기회를 되찾았습니다. <br />
          이 중에는 인도주의 위기에 상황에 처한
          900만 명이 포함됩니다.
        `,
      },
    ],
  },
];

const unicefData = [
  {
    id: 1,
    title: `사회공헌 기금`,
    img: UnicefImg1,
    desc: `
      기부금 출연을 통해 검증된 <br class="m-hide">
      유니세프 프로그램을 뒷받침하여 장기적이고 <br class="m-hide">
      구조적인 아동 권리 개선을 실현합니다.
    `,
  },
  {
    id: 2,
    title: `공익연계 마케팅 <span>(CRM, Cause-Related Marketing)</span>`,
    img: UnicefImg4,
    desc: `
      브랜드와 유니세프가 함께하는 캠페인을 통해,<br class="m-hide">
      소비자 참여형 기부, 매칭 기부, 제품 연계 캠페인 등 마케팅과
      사회공헌을 유기적으로 연결할 수 있습니다.
    `,
  },
  {
    id: 3,
    title: `긴급구호 파트너십`,
    img: UnicefImg2,
    desc: `
      국내외 재난 발생 시 긴급구호 캠페인에 신속히 참여함으로써,
      전 세계 어린이에게 실질적인 도움을 전할 수 있습니다.<br>(예: 지진, 홍수, 감염병 등)
    `,
  },
  {
    id: 4,
    title: `아동권리 옹호 활동`,
    img: UnicefImg3,
    desc: `
      유엔아동권리협약(UNCRC) 이행, 아동친화적 정책 확산,
      인식 제고 활동 등을 통해 아동의 권리를 보호하고<br class="m-hide">
      존중하는 여정에 함께할 수 있습니다.
    `,
  },
];

const brochureData = [
  {
    id: 1,
    icon: 'share',
    title: `파트너십 소개 E-book으로 보기`,
    link: `https://www.unicef.or.kr/data/upload/ebook/donor/Company/`,
  },
  {
    id: 2,
    icon: 'down',
    title: `파트너십 소개 브로셔 다운로드`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L2RvYw%3D%3D&dispFileNm=unicef_csr_introduction.pdf&svrFileNm=unicef_csr_introduction.pdf`,
  },
];

const processData = [
  {
    id: 1,
    title: `초도 미팅`,
    img: processObj1,
    desc: [
      {
        id: 11,
        dec: `
          기업(또는 단체)의 사업 분야와 사회공헌<br>
          목표, 전략 등을 고려하여 유니세프와의<br class="m-hide">
          협력 방안을 논의합니다.
        `,
      },
    ],
  },
  {
    id: 2,
    title: `본부 승인 절차 <span>(Due Dilligence 1, 2)</span>`,
    img: processObj2,
    desc: [
      {
        id: 21,
        dec: `
          유니세프와의 모든 협력은 아동 권리 보호에<br class="m-hide">
          기반하며, 유니세프 내부 규정에 따라 본부의<br class="m-hide">
          공식 심사를 거쳐 승인됩니다.
        `,
      },
    ],
  },
  {
    id: 3,
    title: `협업 모델 구성`,
    img: processObj3,
    desc: [
      {
        id: 31,
        dec: `
          구체적인 협력 모델과<br>
          실행 방안을 설계합니다.
        `,
      },
    ],
  },
  {
    id: 4,
    title: `협약 체결`,
    img: processObj4,
    desc: [
      {
        id: 41,
        dec: `
          정식 협약을 체결하고,<br class="m-hide">
          필요한 경우 PR 활동을 진행합니다.
        `,
      },
    ],
  },
  {
    id: 5,
    title: `프로그램 실행`,
    img: processObj5,
    desc: [
      {
        id: 51,
        dec: `
          글로벌 캠페인, 기업 전략시장 국가에서의<br class="m-hide">
          사업, 국내 아동권리옹호 활동 등 협의된<br class="m-hide">
          다양한 프로그램을 실행합니다.
        `,
      },
    ],
  },
  {
    id: 6,
    title: `결과 보고`,
    img: processObj6,
    desc: [
      {
        id: 61,
        dec: `
          사업 결과에 대한 결과보고를 제공합니다.<br>
          다년 해외 지정 사업 진행 시, 사업 현장 방문<br class="m-hide">
          등의 활동을 진행할 수 있습니다.
        `,
      },
    ],
  },
];

const contactData = [
  {
    id: 1,
    tit: `기업·기관 문의`,
    costumer: `기업후원팀`,
    tel: `02-721-5121~9`,
    email: `esg@unicef.or.kr`,
  },
];

const Title = styled(Tit)`
  margin-bottom: 96px;
  ${breakpoint(`mobile`)} {
    margin-bottom: 72px;
  }
`;

const TitleContainer = styled.div`
  position: relative;
`;

const SwiperCustom = styled(SwiperBasic)`
  .swiper-slide {
    width: 200px;
  }
  &.why-unicef {
    .swiper-button-disabled {
      display: none;
    }
  }
  ${breakpoint(640)} {
    .swiper-slide {
      margin-right: 0;
    }
  }
`;

const BtnWrap = styled.div`
  width: 100%;
  max-width: 352px;
  margin: 0 auto;
  ${breakpoint(640)} {
    width: calc(100% - 40px);
  }
`;

const SectionMain = styled(Section)`
  text-align: center;
  .br_m {
    display: none;
  }

  ${Tit} {
    strong {
      font-weight: 700;
      color: #1cabe2;
    }
  }

  .swiper-slide {
    height: 291px;
    border-radius: 0 0 30px 0;
    overflow: hidden;
    transition: all 0.2s;

    a {
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
    }

    &:hover {
      border-radius: 30px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

      .partner_bg {
        border: none;
        ${Image} {
          &.bg-default {
            opacity: 0;
          }
          &.bg-active {
            opacity: 1;
          }
        }
      }

      .img_sources {
        opacity: 1;
      }

      .partner_logo {
        ${Image} {
          filter: brightness(0) invert(1);
        }
      }
      &:nth-child(1),
      &:nth-child(6) {
        .partner_logo {
          opacity: 0;
        }
      }
    }
  }

  .img_sources {
    font-size: 12px;
    text-align: left;
    color: #fff;
    opacity: 0;
    transition: opacity 0.2s;
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 2;
  }

  .partner_logo {
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 223px;
    z-index: 2;
    ${Image} {
      margin: 0 auto;
      transform: skew(-0.1deg);
      transition: filter 0.2s;
      ${breakpoint(1200)} {
        top: 19vw;
      }
    }
  }

  .partner_bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    border: 1px solid #e5e6e8;
    border-radius: 0 0 30px 0;
    overflow: hidden;
    transition: all 0.2s;
    ${Image} {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
      transition: opacity 0.5s;
      &.bg-active {
        opacity: 0;
      }
    }
  }

  .company-card3 {
    .img_sources {
      text-shadow: 0px 0px 10px #303030;
    }
  }
  .company-card4 {
    .img_sources {
      color: #292d26;
    }
  }

  ${breakpoint(`tablet`)} {
    ${BtnWrap} {
      margin-top: 50px;
    }
    .mobile-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-auto-rows: 1fr;
      gap: 20px 15px;

      .card {
        height: 37vw;
      }
    }
    .swiper-slide {
      height: 100%;
      transition: none;
      border-radius: 0 0 20px 0;

      &:hover {
        border-radius: 0 0 20px 0;
        box-shadow: none;
      }
    }

    .img_sources {
      color: #fff;
      opacity: 1;
      top: 14px;
      left: 9px;
    }
    .partner_bg {
      width: 100%;
      height: 100%;
      border: none;
      top: 0;
      z-index: -1;
      ${Image} {
        object-fit: cover;
        &.bg-default {
          display: none;
        }
        &.bg-active {
          display: block;
          opacity: 1;
          width: 100%;
          height: 100%;
          border-radius: 0;
          top: 0;
        }
      }
    }
    .partner_logo {
      top: initial;
      bottom: 20px;
      ${Image} {
        filter: brightness(0) invert(1);
      }
    }

    .company-card1,
    .company-card6 {
      .partner_logo {
        display: none;
      }
    }
  }

  ${breakpoint(`mobile`)} {
    .only_pc,
    .br_pc {
      display: none;
    }
    .br_m {
      display: block;
    }

    ${Container} {
      padding: 0;
    }
    ${SectionHeader} {
      padding-bottom: 40px;
    }
    .card {
      height: 140px;
    }
    .img_sources {
      font-size: 8px;
      top: 10px;
      left: 10px;
    }
  }
`;
const SectionBody = styled.div``;

const SectionContribution = styled(Section)`
  text-align: center;
  background: #f8f9fa;
  padding: 120px 0;
  .br_m {
    display: none;
  }

  ${SectionHeader} {
    img {
      width: 42px;
      margin-bottom: 30px;
    }
    ${Tit} {
      strong {
        font-weight: 700;
        color: #1cabe2;
      }
    }
  }
  .changing-lists {
    display: flex;
    align-items: flex-start;

    li {
      flex: 1;
      min-height: 340px;
      padding: 68px 18px 70px;
      border: 1px solid #e5e6e8;
      background: #fff;
      transition: all 0.15s;

      & + li {
        margin-left: -1px;
      }

      &:nth-child(2n) {
        margin-top: 40px;
      }

      .changing-icon {
        margin: 0 auto 5px;
        width: 32px;
        height: 32px;
      }
      .changing-number {
        font-size: 32px;

        .changing-unit {
          font-size: 20px;
        }
      }

      p {
        margin-top: 25px;
      }

      &:hover {
        background: #1cabe2;

        .changing-icon {
          filter: brightness(0) invert(1);
          .icon-active {
            display: inline-block;
          }
        }
        .changing-number {
          color: #fff;
        }
        p {
          color: #fff;
          opacity: 0.8;
        }
      }
    }
  }

  ${breakpoint(`tablet`)} {
    background: #f8f9fa;
    padding: 60px 0;

    .changing-lists {
      flex-direction: column;
      gap: 0;

      li {
        flex: auto;
        width: calc(100% - 75px);
        min-height: 154px;
        padding: 50px 18px;

        & + li {
          margin-left: 0;
          margin-top: -1px;
        }

        &:nth-child(2n) {
          margin-top: -1px;
          margin-left: auto;
        }
      }
    }
  }
  ${breakpoint(`mobile`)} {
    .br_pc {
      display: none;
    }
    .br_m {
      display: block;
    }
    ${SectionHeader} {
      img {
        width: 34px;
        margin-bottom: 15px;
      }
    }

    .changing-lists {
      li {
        padding: 20px 18px;

        .changing-icon {
          margin: 0 auto 5px;
          ${Image} {
            width: auto;
          }
        }
        .changing-number {
          font-size: 20px;

          .changing-unit {
            font-size: 14px;
          }
        }

        p {
          margin-top: 5px;
        }
      }
    }
  }
`;

const SectionUnicef = styled(Section)`
  .br_m {
    display: none;
    ${breakpoint(`mobile`)} {
      display: block;
    }
  }
  .method-lists {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 64px 30px;
    position: relative;

    ${breakpoint(`tablet`)} {
      gap: 32px;
    }

    .list-box {
      width: calc(50% - 15px);
      display: flex;

      .img-box {
        width: 120px;
        height: 120px;
        flex-shrink: 0;
        margin-right: 24px;
      }
      .text-box {
        .tit {
          font-size: 20px;
          margin-bottom: 3px;
          span {
            font-size: 16px;
          }
        }
        .desc {
          line-height: 2;
        }
      }

      &:nth-child(n + 3):nth-child(-n + 4) {
        width: 50%;
        padding-right: 44px;
      }

      ${breakpoint(`tablet`)} {
        width: 100%;

        &:nth-child(n + 3):nth-child(-n + 4) {
          width: 100%;
          padding-right: 0;
        }
      }

      ${breakpoint(`mobile`)} {
        .img-box {
          width: 60px;
          height: 60px;
          margin-right: 12px;
        }
        .text-box {
          .tit {
            font-size: 16px;
            span {
              font-size: 14px;
            }
          }
        }
      }
    }

    .list-wrap {
      width: calc(50% - 15px);
      position: absolute;
      right: 0;
      bottom: 54px;

      ${breakpoint(`tablet`)} {
        position: relative;
        width: 100%;
        bottom: 0;
      }

      .btn-onepercent {
        display: block;
        width: 100%;
        min-height: 209px;
        background: #f0fbff url(${UnicefImg5}) no-repeat 0 100% / auto 100%;
        border-radius: 0 0 20px 0;
        padding: 40px 18px 26px 230px;
        margin-bottom: 20px;
        position: relative;

        &::after {
          content: '© UNICEF/UN03267A66/Moreno Gonzalez';
          display: block;
          font-size: 12px;
          color: #828385;
          letter-spacing: -0.8px;
          position: absolute;
          bottom: -20px;
          left: 0;
        }
        &::before {
          content: '';
          display: block;
          width: 24px;
          height: 24px;
          background: url(${IcoShare}) no-repeat 0 0 / auto 100%;
          position: absolute;
          top: 15px;
          right: 15px;
        }

        .tit {
          font-size: 20px;
          font-weight: 700;
          color: #1cabe2;
        }
        .desc {
          margin-top: 6px;
          line-height: 1.625;
          ${breakpoint(1160)} {
            br {
              display: none;
            }
          }
        }

        ${breakpoint(`mobile`)} {
          background-image: url(${UnicefImg5M});
          background-size: auto 100%;
          padding-left: 120px;
          min-height: auto;

          .tit {
            font-size: 16px;
          }
          .desc {
            font-size: 14px;
          }
        }
      }
      ${Button} {
        margin-top: 38px;
      }
    }
  }
  .btn-wrap {
    display: flex;
    gap: 30px;
    margin-top: 50px;

    .col {
      flex: 1;
    }
  }
  ${breakpoint(`tablet`)} {
    .btn-wrap {
      flex-direction: column;
      gap: 16px;
      margin-top: 40px;
    }
  }
  ${Button} {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    ${breakpoint(`mobile`)} {
      padding: 15px 24px;
    }
  }
`;

const DonationNews = styled.article`
  .swiper-slide {
    width: 100% !important;
    margin-right: 32px;

    &:last-child {
      margin-right: 0;
    }

    .img-box {
      padding-top: 19.64%;
    }

    ${breakpoint(`mobile`)} {
      .swiper-slide {
        width: 100%;
      }
    }
  }
`;

const SectionPartner = styled(Section)`
  .SwiperCustom {
    padding: 0;
  }
  .link-item {
    display: block;
    padding: 8px;
    position: relative;
    width: 100%;
    height: auto;
    border: 0;
    background: none !important;

    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      border: 8px solid transparent;
    }

    &:hover:before {
      border-color: #1cabe2;
    }
  }
  .img-box {
    padding-top: 100%;
    width: 100%;
    background-size: 100%;
  }
`;

const SectionProcess = styled(Section)`
  ol {
    display: flex;
    flex-wrap: wrap;
    gap: 130px 0px;
    ${breakpoint(`mobile`)} {
      gap: 50px 0px;
    }

    &.arrow dt {
      &::after {
        transform: translate(calc(50% + 20px), -7px);
        right: 0;
      }
    }
    dd {
      h3 {
        span {
          font-size: 16px;
          ${breakpoint(1160)} {
            display: block;
          }
          ${breakpoint(`mobile`)} {
            display: inline;
          }
        }
      }
    }

    &.arrow > li {
      width: calc(100% / 3);
      margin-bottom: 0;

      &:nth-child(3) {
        dt::after {
          display: none;
        }
        &::after {
          content: '';
          display: block;
          width: 15px;
          height: 44px;
          background: url(${ArrowDownBlue}) no-repeat center / contain;
          position: absolute;
          top: 100%;
          right: initial;
          left: 50%;
          transform: translate(-50%, 50%);
        }
      }
      &:nth-child(4) {
        order: 6;
      }
      &:nth-child(5) {
        order: 5;
      }
      &:last-child {
        order: 4;
      }
      &:nth-child(n + 4):nth-child(-n + 6) {
        dt::after {
          transform: rotate(180deg) translate(calc(50% + 20px), 7px);
          right: initial;
          left: 0;
        }
      }

      ${breakpoint(`tablet`)} {
        &:nth-child(2) {
          dt::after {
            display: block;
          }
        }
      }
      ${breakpoint(`mobile`)} {
        width: 50%;
        padding: 0 30px 0 0;

        dt::after {
          width: 40px;
        }

        &:nth-child(2) {
          dt::after {
            display: block;
            right: -30px;
            transform: translate(0, -7px);
          }
        }
        &:nth-child(3) {
          dt::after {
            display: block;
          }
          &::after {
            display: none;
          }
        }
        &:nth-child(4) {
          order: 4;
        }
        &:nth-child(5) {
          order: 5;
        }
        &:last-child {
          order: 6;
        }
        &:nth-child(n + 4):nth-child(-n + 6) {
          dt::after {
            transform: rotate(0) translate(0, -7px);
            right: -30px;
            left: initial;
          }
        }
      }
    }
  }

  .noti {
    color: #1cabe2;
    margin-top: 40px;

    ${breakpoint(`mobile`)} {
      font-size: 14px;
    }
  }
`;

const CardLayout = styled.div``;

const ContactWrap = styled.div`
  padding: 240px 0 0;
  white-space: pre-line;

  ${breakpoint(`tablet`)} {
    padding: 120px 0;
  }
  ${breakpoint(`mobile`)} {
    padding: 130px 0 0px;
  }
`;

const FormContainer = styled.div`
  max-width: 768px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  ${LabelText} {
    color: #2d2926;
  }
  ${FormGroup} {
    width: 50%;
    padding: 0 16px;
    margin-bottom: 24px;

    &.w50 {
      width: 50% !important;
    }

    &.full {
      width: 100%;
    }

    &.file-group {
      max-width: 544px;
    }

    .tip {
      color: #828385;
      font-size: 14px;
      margin-top: 10px;
      ${breakpoint(640)} {
        font-size: 12px;
      }
    }

    .chk-label {
      position: relative;
      padding-left: 30px;
    }
  }

  ${breakpoint(`tablet`)} {
    margin: 0 -12px;

    ${FormGroup} {
      width: 100%;
      padding: 0 12px;
    }
  }
`;

const NavigationButton = styled.div`
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  font-size: 20px;
  position: relative;

  ${breakpoint(640)} {
    font-size: 16px;
    padding: 20px 40px 20px 0;
  }
`;
const AccordionBody = styled.div`
  padding: 24px;
  font-size: 16px;
  color: #2d2926;
  white-space: pre-line;
  ${breakpoint(`mobile`)} {
    font-size: 14px;
    padding: 16px 0;
  }
  // blut css 보정
  ul,
  ol,
  li {
    list-style: inherit;
    list-style-position: inside;
    list-style-type: inherit;
  }
  ol {
    list-style-type: demical;
  }
  ul {
    list-style-type: disc;
  }
  a {
    color: #1cabe2;
  }
`;

const SectionInquiry = styled(Section)`
  ${SectionHeader} {
    padding-bottom: 60px;
  }
  ${BtnWrap} {
    margin-top: 36px;
  }
  ${NavigationButton} {
    padding: 0 20px !important;
  }
  .contactus {
    .is-active {
      border-bottom: none;
    }
  }
  ${breakpoint(`mobile`)} {
    padding-top: 60px;
    ${SectionHeader} {
      padding-bottom: 36px;
    }
    ${FormGroup} {
      margin-bottom: 8px;

      &.file-group {
        margin-bottom: 24px;
        ${Row} {
          margin-bottom: 0;
        }
      }
      .tip {
        margin-top: 10px;
      }
    }
    ${BtnWrap} {
      margin-top: 32px;
    }
  }
`;
const SectionFaq = styled(Section)`
  padding-bottom: 0;
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
`;

// 카운팅 효과
const formatNumber = (num) => num.toLocaleString();
const CountUp = ({ targetNumber, duration = 2000, startCounting }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!startCounting) return;

    let start = 0;
    const end = targetNumber;
    const incrementTime = 30;
    const totalSteps = duration / incrementTime;
    const increment = end / totalSteps;

    const timer = setInterval(() => {
      start += increment;
      setCount(Math.round(start));
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      }
    }, incrementTime);

    return () => clearInterval(timer);
  }, [targetNumber, duration, startCounting]);

  return <span>{formatNumber(count)}</span>;
};

// 한 페이지당 보여줄 아이템 수
const pagePerCount = 8;

export interface FaqData {
  id: string | number;
  title?: string;
  contents?: string;
}

type ADDRESS_TYPE = typeof ADDRESS;
interface ContactData {
  socialType: string; // 구분(기업 or 기관/재단/단체)
  socialCompanyName: string; // 기업/단체명
  socialAddress1: keyof ADDRESS_TYPE; // 소재지(시/도)
  socialAddress2: string; // 소재지(시/군/구)
  socialManagerName: string; // 담당자명
  socialDepartment?: string; // 부서명
  socialContact: string; // 연락처(&lsquo;-&rsquo;제외)
  socialEmail: string; // 이메일 주소
  socialContents: string; // 문의내용
  socialIsAgreeYn: boolean; // 기업기관후원안내 동의여부 (Y/N)
}

const Contribution: React.FC<PageProps> = ({ location }) => {
  const { hash } = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [faqLists, setFaqLists] = useState<FaqData[]>([]);
  const [partners, setPartners] = useState<PartnerData[]>([]);
  const [campaigns, setCampaigns] = useState<CampaignData[]>([]);
  const [donationNews, setDonationNews] = useState<CampaignData[]>([]);
  const [page, setPage] = useState(1); // 현재 페이지
  const [total, setTotal] = useState(0); // 전체 글 수 (현재 조건기준)
  const [newsLists, setNewsLists] = useState<Article[]>([]);
  const hasMore = useMemo(() => total > pagePerCount * page, [page, total]);
  const loadFaqLists = useCallback(async () => {
    try {
      const { data } = await BoardCommonControllerService.foListUsingGet({
        boardCategoryCode: ['260'],
        optData1: '1',
        optData2: '103',
        pagePerCount: 6,
        statusCode: '1',
      });
      const organizationFaq = data as any;
      setFaqLists(
        organizationFaq.map((faq: BoardVo) => ({
          id: faq.boardIndexNumber,
          title: faq.subject,
          contents: faq.contents,
        })),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  const loadPartners = useCallback(async () => {
    try {
      const {
        data: organizationLogo,
      } = await CorporateControllerService.getCsrLogoListUsingGet();
      setPartners(
        organizationLogo.map((logo: CsrVo) => ({
          id: logo.indexNumber,
          indexNumber: logo.indexNumber,
          title: logo.csrName,
          category1: logo.csrCate1,
          category2: logo.csrCate2,
          url: logo.csrSite,
          year: logo.csrYear,
          desc: logo.csrDesc,
          imgPath: logo.logoAttGrpNo,
          csrDetailUrl: logo.csrDetailUrl,
        })),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  const loadCampaigns = useCallback(async () => {
    try {
      const {
        data: articles,
      } = await BoardCommonControllerService.foListAllUsingGet({
        boardCategoryCode: ['200'],
        optData2: '2',
        outDateDispYn: 'Y',
      });
      setCampaigns(
        articles
          .map((article: BoardVo) => ({
            id: article.boardIndexNumber,
            pcImage: article.imgAttGrpNoTn,
            mobileImage: article.imgAttGrpNoTn,
            link: article.referUrl || EVENT_LIST_URI + article.boardIndexNumber,
          }))
          .sort((a, b) => new Date(b.date) - new Date(a.date) || b.id - a.id),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  const loadDonationNews = useCallback(async () => {
    try {
      const {
        data: partnershipBanners,
      } = await FoBannerControllerService.selectBannerListUsingGet({
        kind: '4001',
      });
      setDonationNews(
        partnershipBanners.map((banner: FoBannerVo) => ({
          id: banner.indexNumber,
          pcImage: banner.imgAttGrpNoPc,
          mobileImage: banner.imgAttGrpNoMobile,
          link: banner.targetUrl,
        })),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  const loadItem = useCallback(
    () =>
      BoardCommonControllerService.foListUsingGet({
        boardCategoryCode: [BOARD_KIND_PARTNER],
        pagePerCount,
        page,
      })
        // eslint-disable-next-line @typescript-eslint/no-shadow
        .then(({ data, totalCount }) => {
          setNewsLists((prevEvents) => [...prevEvents, ...data]);
          setTotal(totalCount);
        })
        .catch((e) => {
          console.error(e);
        }),
    [page],
  );

  useEffect(() => {
    loadFaqLists();
    loadPartners();
    loadCampaigns();
    loadDonationNews();
    loadItem();
  }, [loadCampaigns, loadDonationNews, loadFaqLists, loadPartners, loadItem]);

  // 다음 페이지 로드
  const loadNextPage = () => {
    setPage(page + 1);
  };

  const popupStore = usePopupStore();
  const [addressVal, setAddressVal] = useState(``);
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
    reset,
  } = useForm<ContactData>({
    defaultValues: {
      socialType: ``,
      socialCompanyName: ``,
      socialAddress1: undefined,
      socialAddress2: undefined,
      socialManagerName: ``,
      socialDepartment: ``,
      socialContact: ``,
      socialEmail: ``,
      socialContents: ``,
      socialIsAgreeYn: false,
    },
  });
  const socialAddress = watch(`socialAddress1`);
  // 첨부파일
  const [files, setFiles] = useState<File[]>([]);

  const onSubmit: SubmitHandler<ContactData> = useCallback(
    async ({
      socialType,
      socialCompanyName,
      socialAddress1,
      socialAddress2,
      socialManagerName,
      socialDepartment,
      socialContact,
      socialEmail,
      socialContents,
      socialIsAgreeYn,
      ...formData
    }) => {
      try {
        let attGrpNo: any;
        // 파일이 있다면
        if (files.length > 0) {
          const result = await AttFileControllerService.uploadUsingPost({
            file: files,
          });
          attGrpNo = result.data.attGrpNo;
        }

        const {
          resultCode,
          resultMessage,
        } = await CorporateControllerService.postQnaInsertUsingPost({
          ...formData,
          type: socialType,
          companyName: socialCompanyName,
          address1: socialAddress1 || '',
          address2: socialAddress2 || '',
          managerName: socialManagerName,
          department: socialDepartment || '',
          contact: socialContact,
          email: socialEmail,
          contents: socialContents,
          isAgreeYn: socialIsAgreeYn ? `Y` : `N`,
          attGrpNo,
        });
        popupStore.show(resultMessage);
        // 성공후 폼 리셋
        reset();
        setFiles([]);
      } catch (e) {
        popupStore.show(`문의 등록에 실패했습니다. 다시 시도해주세요.`);
        // console.error(e);
      }
    },
    [files, popupStore, reset],
  );

  // 상단 탭
  const [activePath, setActivePath] = useState(location.pathname);
  const handleTabClick = (idx: number, link: string) => {
    setActivePath(link);
    router.push(link);
  };

  if (typeof window === 'undefined') return null;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 990);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 990);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // 초기 실행

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function chunkArray(arr, size) {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }

  // 섹션 도달하면 카운팅 모션 실행하기
  const sectionCountRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.boundingClientRect.top <= 0) {
          setIsVisible(true);
          observer.disconnect(); // 한 번 실행 후 옵저버 해제
        }
      },
      { threshold: 0, rootMargin: '0px 0px -100% 0px' }, // 화면 상단에 닿으면 실행
    );

    if (sectionCountRef.current) {
      observer.observe(sectionCountRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // 문의하기로 스크롤 이동
  const sectionRef = useRef(null);
  const handleScroll = () => {
    sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  console.log('hash >> ', hash);
  return (
    <LayoutWithTitle
      location={location}
      title="기업·기관 사회공헌"
      description="for every child, partnerships"
    >
      {/* <ContributionTab currentPath={location.pathname} /> */}

      <SectionMain className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">
                {/* <PageComponent id="title1"> */}
                유니세프의 기업 파트너십은 <br className="br_m" />
                <strong> 미래 세대를 위해</strong> <br className="br_pc" />
                <strong>
                  지속가능한 <br className="br_m" />
                  문제 해결 방식
                </strong>
                을 추구합니다.
                {/* </PageComponent> */}
              </Tit>
            </h2>
            <p className="header-dec">
              <PageComponent id="content1">
                약 80년의 경험과 전문성, 전 세계 190여 개 국가 네트워크,{' '}
                <br className="br_m" /> 글로벌 NGO 브랜드 호감도 1위 <br />전
                세계 어린이가{' '}
                <span className="only_pc">행복한 어린 시절을 보내고</span>{' '}
                본인이 원하는 어른으로 성장할 수 있도록, <br className="br_m" />{' '}
                유니세프와 함께 해주세요.
              </PageComponent>
            </p>
          </SectionHeader>
          <SectionBody>
            {partnerListData.length > 0 && (
              <SwiperCustom className="swiper-intro" overflowHidden>
                <Swiper
                  slidesPerView={isMobile ? 1 : 4}
                  slidesPerGroup={1}
                  spaceBetween={isMobile ? 15 : 25}
                  navigation
                  scrollbar={{ draggable: true }}
                >
                  {isMobile
                    ? chunkArray(partnerListData, 4).map((group, index) => (
                        <SwiperSlide key={index}>
                          <div className="mobile-grid">
                            {group.map((row, idx) => (
                              <div
                                className={`card company-card${row.id}`}
                                key={idx}
                              >
                                <LinkSafe to={row.link}>
                                  <div className="partner_bg">
                                    <Image
                                      className="bg-default"
                                      pcSrc={row.img}
                                      mobileSrc={row.img}
                                      alt={row.partner}
                                    />
                                    <Image
                                      className="bg-active"
                                      pcSrc={row.imgOn}
                                      mobileSrc={row.imgOn}
                                      alt={row.partner}
                                    />
                                  </div>
                                  <div
                                    className="img_sources"
                                    dangerouslySetInnerHTML={{
                                      __html: row.sources,
                                    }}
                                  />
                                  <div className="partner_logo">
                                    <Image
                                      pcSrc={row.logo}
                                      mobileSrc={row.logoM}
                                      alt={row.partner}
                                    />
                                  </div>
                                </LinkSafe>
                              </div>
                            ))}
                          </div>
                        </SwiperSlide>
                      ))
                    : partnerListData.map((row, index) => (
                        <SwiperSlide
                          key={index}
                          className={`company-card${row.id}`}
                        >
                          <LinkSafe to={row.link}>
                            <div className="partner_bg">
                              <Image
                                className="bg-default"
                                pcSrc={row.img}
                                mobileSrc={row.img}
                                alt={row.partner}
                              />
                              <Image
                                className="bg-active"
                                pcSrc={row.imgOn}
                                mobileSrc={row.imgOn}
                                alt={row.partner}
                              />
                            </div>
                            <div
                              className="img_sources"
                              dangerouslySetInnerHTML={{ __html: row.sources }}
                            />
                            <div className="partner_logo">
                              <Image
                                pcSrc={row.logo}
                                mobileSrc={row.logoM}
                                alt={row.partner}
                              />
                            </div>
                          </LinkSafe>
                        </SwiperSlide>
                      ))}
                </Swiper>
              </SwiperCustom>
            )}
            <BtnWrap>
              <Button width={350} onClick={handleScroll}>
                함께하기
              </Button>
            </BtnWrap>
          </SectionBody>
        </Container>
      </SectionMain>

      <SectionContribution ref={sectionCountRef}>
        <Container>
          <SectionHeader className="with-desc">
            <img src={Obj0} alt="" />
            <h2>
              <Tit size="s1">
                파트너사와 유니세프는 <br />
                <strong>
                  전 세계 어린이를 위한 <br className="br_m" />
                  지속가능한 변화
                </strong>
                를 주도합니다.
              </Tit>
            </h2>
            <p className="header-dec">
              2024년, 파트너사와 유니세프는 <br className="br_m" /> 다음과 같은
              변화를 이끌어냈습니다.
            </p>
          </SectionHeader>
          <CardLayout>
            <ul className="changing-lists">
              {countingData.map((row) => (
                <li key={row.id}>
                  <div
                    className="changing-icon"
                    css={`
                      background: url(${row.img}) no-repeat 0 0 / contain;
                    `}
                  />

                  <Tit size="s4" color="sky" className="changing-number">
                    <CountUp
                      targetNumber={parseInt(row.number.replace(/,/g, ''), 10)}
                      startCounting={isVisible}
                    />{' '}
                    <span
                      className="changing-unit"
                      dangerouslySetInnerHTML={{ __html: row.unit }}
                    />
                  </Tit>
                  {row.desc.map((row2) => (
                    <p
                      key={row2.id}
                      dangerouslySetInnerHTML={{ __html: row2.dec }}
                    />
                  ))}
                </li>
              ))}
            </ul>
          </CardLayout>
        </Container>
      </SectionContribution>

      <SectionUnicef className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">유니세프와 함께하는 방법</Tit>
            </h2>
          </SectionHeader>

          <div className="method-lists">
            {unicefData.map((row) => (
              <div className="list-box" key={row.id}>
                <div
                  className="img-box"
                  css={`
                    background: url(${row.img}) no-repeat 0 0 / contain;
                  `}
                />
                <div className="text-box">
                  <p className="tit">
                    <strong dangerouslySetInnerHTML={{ __html: row.title }} />
                  </p>
                  <p
                    className="desc"
                    dangerouslySetInnerHTML={{ __html: row.desc }}
                  />
                </div>
              </div>
            ))}
            <div className="list-wrap">
              <LinkSafe
                to="/involve/corporate-and-organization/one-percent-miracle"
                className="btn-onepercent"
              >
                <div className="tit">1%의 기적 프로그램</div>
                <p className="desc">
                  급여 끝자리, 마일리지, 동전 모금 등 <br className="m-hide" />
                  기업과 임직원, 고객이 함께 참여할 수 있는{' '}
                  <br className="m-hide" />
                  소액 기부 캠페인으로, 작지만 지속가능한{' '}
                  <br className="m-hide" />
                  나눔을 실천할 수 있습니다.
                </p>
              </LinkSafe>
            </div>
          </div>

          <div className="btn-wrap">
            {brochureData.map((row) => (
              <div className="col" key={row.id}>
                <Button
                  ico={row.icon}
                  outline
                  full
                  onClick={() => window.open(row.link)}
                >
                  <span className="ico">{row.title}</span>
                </Button>
              </div>
            ))}
          </div>

          {donationNews.length === 0 ? (
            ``
          ) : (
            <DonationNews>
              <h4>
                <Tit size="s2">후원 소식</Tit>
              </h4>
              <CampaignCard
                campaigns={donationNews}
                img
                autoplay
                overflowHidden
              />
            </DonationNews>
          )}
        </Container>
      </SectionUnicef>

      <SectionPartner>
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">유니세프와 함께하는 기업·기관</Tit>
            </h2>
          </SectionHeader>
          <ContributionLogo partners={partners} />
        </Container>
      </SectionPartner>

      <SectionNews className="by-sub-main-layout">
        <Container>
          <SectionHeader>
            <h2>
              <Tit size="s1">파트너십 소식</Tit>
            </h2>
          </SectionHeader>
          <ThumbnailCardSample newsLists={newsLists} />
          {hasMore && (
            <ButtonContainer>
              <Button
                outline
                width={352}
                ico="moreArrow"
                onClick={() => {
                  loadNextPage();
                }}
              >
                <span className="ico">더 보기</span>
              </Button>
            </ButtonContainer>
          )}
        </Container>
      </SectionNews>

      <SectionProcess className="by-sub-main-layout" backgroundColor="#E2F0F6">
        <Container>
          <SectionHeader>
            <h2>
              <Tit size="s1">파트너십 체결 절차</Tit>
            </h2>
          </SectionHeader>
          <ProcessList itemData={processData} arrow />
          <p className="noti">
            *기부금 영수증은 기부금 수령 후 상시 발급가능합니다.
          </p>
        </Container>
      </SectionProcess>

      <SectionFaq className="by-sub-main-layout">
        <Container>
          <TitleContainer>
            <Title size="s1">자주 묻는 질문</Title>
            <MoreViewLink to="/faq?category=1&optData2=103#categorySection">
              <span>더 보기</span>
            </MoreViewLink>
          </TitleContainer>
          {faqLists.length > 0 && (
            <AccordionComponent initialKey={faqLists[0].id}>
              {faqLists.map((faq) => (
                <AccordionItem
                  key={faq.id}
                  toggleKey={faq.id}
                  renderToggle={(onClick) => (
                    <NavigationButton
                      onClick={onClick}
                      className="accordion-opener"
                    >
                      {faq.title}
                    </NavigationButton>
                  )}
                >
                  <AccordionBody
                    dangerouslySetInnerHTML={{ __html: faq.contents || `` }}
                  />
                </AccordionItem>
              ))}
            </AccordionComponent>
          )}
        </Container>
      </SectionFaq>

      <SectionInquiry
        id="sectionInquiry"
        className="by-sub-main-layout"
        ref={sectionRef}
        backgroundColor="#F8F9FA"
      >
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">문의하기</Tit>
            </h2>
          </SectionHeader>
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormContainer>
              <FormGroup className="FormGroup">
                <Row>
                  <LabelText require>기업·단체명</LabelText>
                </Row>
                <Row>
                  <InputText
                    placeholder="기업·단체명"
                    name="socialCompanyName"
                    ref={register({
                      required: {
                        value: true,
                        message: `기업·단체명을 입력해주세요.`,
                      },
                      maxLength: {
                        value: 50,
                        message: `50자 이내로 입력해주세요.`,
                      },
                    })}
                  />
                </Row>
                {errors.socialCompanyName && (
                  <ErrorMessage>
                    {errors.socialCompanyName.message}
                  </ErrorMessage>
                )}
              </FormGroup>

              <FormGroup className="FormGroup">
                <Row>
                  <LabelText require>담당자명</LabelText>
                </Row>
                <Row>
                  <InputText
                    placeholder="담당자명 입력"
                    name="socialManagerName"
                    ref={register({
                      required: {
                        value: true,
                        message: `담당자명을 입력해주세요.`,
                      },
                      maxLength: {
                        value: 50,
                        message: `50자 이내로 입력해주세요.`,
                      },
                    })}
                  />
                </Row>
                {errors.socialManagerName && (
                  <ErrorMessage>
                    {errors.socialManagerName.message}
                  </ErrorMessage>
                )}
              </FormGroup>
              <FormGroup className="FormGroup">
                <Row>
                  <LabelText require>연락처</LabelText>
                </Row>
                <Row>
                  <Controller
                    control={control}
                    name="socialContact"
                    rules={{
                      required: {
                        value: true,
                        message: `연락처를 입력해주세요.`,
                      },
                      pattern: {
                        value: mobileRegex,
                        message: `올바른 연락처 형식이 아닙니다.`,
                      },
                      validate: {
                        isValidRange: (value) =>
                          (value.substr(0, 3) === `010` &&
                            value.length === 11) ||
                          (value.substr(0, 3) !== `010` &&
                            value.length === 10) ||
                          `휴대폰번호 자릿수를 확인해주세요`,
                      },
                    }}
                    as={
                      <InputNumber
                        format="###########"
                        placeholder="연락처 입력 ( &lsquo;-&rsquo; 제외 )"
                      />
                    }
                  />
                </Row>
                {errors.socialContact && (
                  <ErrorMessage>{errors.socialContact.message}</ErrorMessage>
                )}
              </FormGroup>
              <FormGroup className="FormGroup">
                <Row>
                  <LabelText require>이메일</LabelText>
                </Row>
                <Row>
                  <InputText
                    name="socialEmail"
                    ref={register({
                      required: {
                        value: true,
                        message: `이메일을 입력해주세요.`,
                      },
                      pattern: {
                        value: emailRegex,
                        message: `올바른 이메일 형식이 아닙니다.`,
                      },
                      maxLength: {
                        value: 100,
                        message: `100자 이내로 입력해주세요.`,
                      },
                    })}
                    placeholder="이메일주소 입력"
                  />
                </Row>
                {errors.socialEmail && (
                  <ErrorMessage>{errors.socialEmail.message}</ErrorMessage>
                )}
              </FormGroup>
              <FormGroup className="FormGroup full">
                <Row>
                  <LabelText require>문의 내용</LabelText>
                </Row>
                <Row>
                  <InputTextarea
                    placeholder="문의 내용을 입력하세요.&#13;&#10;후원 규모를 대략적으로 적어주시면 빠른 답변에 도움이 됩니다."
                    name="socialContents"
                    ref={register({
                      required: {
                        value: true,
                        message: `문의 내용을 입력해주세요.`,
                      },
                      maxLength: {
                        value: 1200,
                        message: `1200자 이내로 입력해주세요.`,
                      },
                    })}
                    css={`
                      ${breakpoint(`mobile`)} {
                        height: 140px;
                      }
                    `}
                  />
                </Row>
                {errors.socialContents && (
                  <ErrorMessage>{errors.socialContents.message}</ErrorMessage>
                )}
              </FormGroup>

              <FormGroup className="file-group full">
                <Attachment
                  accept="application/pdf"
                  multiple
                  files={files}
                  onFilesChange={setFiles}
                />
                <p className="tip">※첨부파일 (최대 5개의 PDF 형식만 가능)</p>
              </FormGroup>
              <FormGroup className="chk-group full">
                <InputCheckbox
                  label="예, 저는 기업·기관 후원 안내를 받고 싶습니다. 그리고 안내를 원치 않을 시, 언제든지 수신 거부 할 수 있음을 잘 알고 있습니다."
                  name="socialIsAgreeYn"
                  ref={register({ required: true })}
                />
                {errors.socialIsAgreeYn && (
                  <ErrorMessage>약관 동의에 체크해주세요.</ErrorMessage>
                )}
              </FormGroup>
            </FormContainer>
            <BtnWrap>
              <Button full type="submit">
                문의하기
              </Button>
            </BtnWrap>
          </form>
        </Container>
      </SectionInquiry>

      <Container>
        <ContactWrap>
          <h3 className="a11y">문의</h3>
          <ContactUs itemData={contactData} />
        </ContactWrap>
      </Container>
    </LayoutWithTitle>
  );
};

export default Contribution;
